import { render, staticRenderFns } from "./footerBtnModules.vue?vue&type=template&id=0d190d2c&scoped=true&"
import script from "./footerBtnModules.vue?vue&type=script&lang=js&"
export * from "./footerBtnModules.vue?vue&type=script&lang=js&"
import style0 from "./footerBtnModules.vue?vue&type=style&index=0&id=0d190d2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d190d2c",
  null
  
)

export default component.exports